// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__IlFpU","buttons":"Footer_buttons__3bTQH"};